import type { Snapshot } from '@ember-data/legacy-compat/-private';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type { ConditionalStrategy, RecommendationStrategy } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class RecommendationStrategySerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    conditionalStrategies: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serializeHasMany(
    snapshot: Snapshot,
    json: Record<string, unknown>,
    relationship: { name: string },
  ) {
    const key = relationship.name;

    if (key === 'conditionalStrategies') {
      // Ember data by default omits id
      // However, BE explicitly required id: null in the payload to determine if it is a new conditional strategy
      // @ts-expect-error: 'snapshot.record' is of type 'unknown'.
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      json['conditional_strategies'] = snapshot.record
        .get(key)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .map((record: ConditionalStrategy) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
          return {
            // @ts-expect-error: Spread types may only be created from object types.
            ...record.serialize(),
            id: record.id ? parseInt(record.id, 10) : null,
          };
        });
    }
  }

  /*
    This method is used to remove the parent key from the payload, so that the API accepts the payload.
    By default, the payload for saving a record would be:
      {
        recommendationStrategy: {
          payload
        }
      }
    Instead, we want the payload to be:
      {
        payload
      }
  */

  serializeIntoHash(
    hash: RecommendationStrategy,
    _ModelClass: unknown,
    snapshot: Snapshot,
    options: { excludeUnchangedAttributes: boolean },
  ): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const serializedData = this.serialize(snapshot, options);
    Object.assign(hash, {
      ...serializedData,
      // Include the `id` attribute in the serialized data
      // BE requires this ID to be an integer
      // @ts-expect-error: Argument of type 'string | null' is not assignable to parameter of type 'string'.
      id: parseInt(snapshot.id, 10),
    });
  }
}
